import React from "react";
import PropTypes from "prop-types";
import { selectEvent } from "../../../redux/preferences/selectors";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { getAllMaterialRequests } from "../../../services/api/materialRequests";

class _DashboardWidgetMaterialRequests extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      materialRequests: []
    };
  }

  static propTypes = {
    event: PropTypes.object
  };

  UNSAFE_componentWillMount() {
    getAllMaterialRequests({
      "filter[event_id]": this.props.event.id,
      "filter[current_status]": "pending",
      include: "registration,registration.company"
    }).then(response => {
      this.setState({
        materialRequests: response.data
      });
    });
  }

  render() {
    const { materialRequests } = this.state;

    return (
      <div className="m-portlet m-portlet--full-height">
        <div className="m-portlet__head">
          <div className="m-portlet__head-caption">
            <div className="m-portlet__head-title">
              <span className="m-portlet__head-icon">
                <i className="flaticon-support" />
              </span>
              <h3 className="m-portlet__head-text">
                Latest Material Requests to review
              </h3>
            </div>
          </div>
          <div className="m-portlet__head-tools">
            <ul className="m-portlet__nav">
              <li className="m-portlet__nav-item">
                <Link
                  to="/admin/material-requests"
                  className="m-portlet__nav-link btn btn-accent m-btn m-btn--icon m-btn--icon-only m-btn--pill"
                >
                  <i className="la la-eye" />
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="m-portlet__body">
          {materialRequests.length === 0 && (
            <div className="text-center flex flex-col items-center">
              <p>Good job! No material requests waiting for review.</p>
              <img
                src="/assets/img/good-job.png"
                alt=""
                style={{width: "100%", maxWidth: "200px"}}
              />
            </div>
          )}

          {materialRequests.length > 0 && (
            <table className="table m-table m-table">
              <tbody>
              {materialRequests.map(material => (
                  <tr key={material.id}>
                    <td>{material.registration.company.name}</td>
                    <td style={{ textAlign: "right" }}>
                      <Link
                        to={`/admin/material-requests`}
                        className="btn btn-outline-primary m-btn btn-sm  m-btn--icon m--margin-left-5"
                      >
                        <span>
                          <i className="la la-eye" />
                          <span>Review</span>
                        </span>
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({});

const mapStateToProps = function(state) {
  return {
    event: selectEvent(state)
  };
};

const DashboardWidgetMaterialRequests = connect(
  mapStateToProps,
  mapDispatchToProps
)(_DashboardWidgetMaterialRequests);

export default DashboardWidgetMaterialRequests;
